<div class="relative flex flex-col w-full h-full">

  <!-- spinner -->
  <div *ngIf="isLoading" class="flex h-full w-full justify-center items-center">
    <svg
      aria-hidden="true"
      class="w-12 h-12 text-gray-200 animate-spin dark:text-gray-600 fill-[#141F58] items-center justify-center mx-auto"
      viewBox="0 0 100 101"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M100 50.5908C100 78.2051 77.6142 100.591 50 100.591C22.3858 100.591 0 78.2051 0 50.5908C0 22.9766 22.3858 0.59082 50 0.59082C77.6142 0.59082 100 22.9766 100 50.5908ZM9.08144 50.5908C9.08144 73.1895 27.4013 91.5094 50 91.5094C72.5987 91.5094 90.9186 73.1895 90.9186 50.5908C90.9186 27.9921 72.5987 9.67226 50 9.67226C27.4013 9.67226 9.08144 27.9921 9.08144 50.5908Z"
        fill="currentColor"
      />
      <path
        d="M93.9676 39.0409C96.393 38.4038 97.8624 35.9116 97.0079 33.5539C95.2932 28.8227 92.871 24.3692 89.8167 20.348C85.8452 15.1192 80.8826 10.7238 75.2124 7.41289C69.5422 4.10194 63.2754 1.94025 56.7698 1.05124C51.7666 0.367541 46.6976 0.446843 41.7345 1.27873C39.2613 1.69328 37.813 4.19778 38.4501 6.62326C39.0873 9.04874 41.5694 10.4717 44.0505 10.1071C47.8511 9.54855 51.7191 9.52689 55.5402 10.0491C60.8642 10.7766 65.9928 12.5457 70.6331 15.2552C75.2735 17.9648 79.3347 21.5619 82.5849 25.841C84.9175 28.9121 86.7997 32.2913 88.1811 35.8758C89.083 38.2158 91.5421 39.6781 93.9676 39.0409Z"
        fill="currentFill"
      />
    </svg>
  </div>

  <ng-container *ngIf="!isLoading">

    <!-- ============================================ -->
    <!-- HEADER - outside the scroll          -->
    <!-- ============================================ -->
    <div class="flex-none border-b border-gray-200">
      <table class="w-full table-fixed">
        <thead>
          <tr class="bg-[#F9FAFB] h-11 xl:h-14 text-gray-500 text-[0.5rem] xl:text-[0.62rem] 2xl:text-[0.67rem]">
            <th class="py-3 pl-[16px] text-left w-[19%]">
              <h2>REGIONI</h2>
            </th>
            <th class="py-3 text-center w-[20%]">
              <h2>DA GU A FORECAST</h2>
            </th>
            <th class="py-3 text-center w-[20%]">
              <h2>DA GU AD ACTUAL</h2>
            </th>
            <th class="py-3 text-center w-[19%]">
              <div class="flex justify-center items-center">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="19"
                  height="18"
                  viewBox="0 0 19 18"
                  fill="none"
                  class="w-[15px] h-[14px] xl:w-[18px] xl:h-[17px]"
                >
                  <path
                    d="M16.6583 14.6081H2.8418L9.75005 2.64258L16.6583 14.6081Z"
                    [attr.stroke]="hasData ? '#6B7280' : '#D1D5DB'"
                    stroke-width="0.5"
                    stroke-linecap="round"
                    stroke-linejoin="round"
                  />
                </svg>
              </div>
            </th>
          </tr>
        </thead>
      </table>
    </div>

    <!-- ============================================ -->
    <!-- BODY - scrollable  -->
    <!-- ============================================ -->
    <div class="relative flex-1 overflow-y-auto scrollbar2 min-h-0">

      <!-- No data message -->
      <div *ngIf="!hasData" class="absolute inset-0 flex items-center justify-center z-10 pointer-events-none">
        <p class="text-gray-400 font-medium text-[0.7rem] 2xl:text-[0.75rem] 3xl:text-[0.8rem] bg-sky-100 px-4 py-2 rounded-sm">
          Non ci sono dati da mostrare
        </p>
      </div>

      <!-- ============================================ -->
      <!-- PLACEHOLDER TABLE - When NO data exists     -->
      <!-- ============================================ -->
      <table *ngIf="!hasData" class="w-full table-fixed opacity-40">
        <colgroup>
          <col class="w-[19%]" />
          <col class="w-[20%]" />
          <col class="w-[20%]" />
          <col class="w-[19%]" />
        </colgroup>
        <tbody>
          <tr
            *ngFor="let row of rows"
            class="h-[58px] text-center border-b border-gray-100 text-gray-500 text-[0.5rem] xl:text-[0.6rem] 2xl:text-[0.65rem]"
          >
            <td class="py-2 text-left pl-[16px]">
              <h5>{{ row.regionName }}</h5>
            </td>
            <td class="py-2 text-center"><h5>---</h5></td>
            <td class="py-2 text-center"><h5>---</h5></td>
            <td class="py-2 text-center"><h5>---</h5></td>
          </tr>
        </tbody>
      </table>

      <!-- ============================================ -->
      <!-- REAL TABLE - When data exists               -->
      <!-- ============================================ -->
      <table *ngIf="hasData" class="w-full table-fixed">
        <colgroup>
          <col class="w-[19%]" />
          <col class="w-[20%]" />
          <col class="w-[20%]" />
          <col class="w-[19%]" />
        </colgroup>
        <tbody>
          <tr
            *ngFor="let row of rows"
            class="h-[58px] text-center border-b border-gray-100 text-dimot-1 text-[0.5rem] xl:text-[0.6rem] 2xl:text-[0.65rem]"
          >
            <td class="py-2 text-left pl-[16px]">
              <h5>
                {{
                  row.regionName === "Prov. Aut. di Bolzano"
                    ? "PA di Bolzano"
                    : row.regionName === "Prov. Aut. di Trento"
                      ? "PA di Trento"
                      : row.regionName
                }}
              </h5>
            </td>
            <td class="py-2 text-center">
              <h5>{{ row.forecast != null ? row.forecast : "---" }}</h5>
            </td>
            <td class="py-2 text-center">
              <h5>{{ row.actual != null ? row.actual : "---" }}</h5>
            </td>
            <td
              *ngIf="row.actual != null && row.forecast != null; else noData"
              [ngClass]="getStatusDelta(row.delta)"
              class="py-2 text-center h-14"
            >
              <div class="flex flex-row justify-center items-center">
                <h5 *ngIf="row.delta > 0">+</h5>
                <h5>{{ row.delta }}</h5>
              </div>
            </td>
            <ng-template #noData>
              <td>---</td>
            </ng-template>
          </tr>
        </tbody>
      </table>

    </div>
  </ng-container>

</div>